function getCookie(name) {
  var cookie = document.cookie;
  var prefix = name + '=';
  var begin = cookie.indexOf('; ' + prefix);
  if (begin == -1) {
    begin = cookie.indexOf(prefix);
    if (begin != 0) {
      return null;
    }
  }
  else {
    begin += 2;
    var end = document.cookie.indexOf(';', begin);
    if (end == -1) {
      end = cookie.length;
    }
  }
  return cookie.substring(begin + prefix.length, end);
}

function signupPopup() {
  var cookie = getCookie('OptanonAlertBoxClosed');

  if (!cookie) {
    var documentHeight = document.body.clientHeight;
    var center = (documentHeight - (documentHeight / 4)) / 2;

    // if (document.getElementById('signup-modal-open-button')) {
    if (document.getElementsByClassName('signup-modal-popup-main-container')) {
      document.addEventListener('scroll', function() {

        if (window.pageYOffset > center) {
          if (document.getElementById('signup-modal-open-button')) {
            document.getElementById('signup-modal-open-button').click();
            document.getElementById('main-wrapper').style.zIndex = -1;
          }
        }
      });
    }
  }
}
